import moment from 'moment'

const toTable = (suggestion) => {
  let text = suggestion.text
  if (suggestion.text.length > 60) {
    text = `${text.slice(0, 60)} ...`
  }

  return {
    id: suggestion.id,
    user: suggestion.user,
    text,
    sent: moment(suggestion.created_at).unix()
  }
}

export default {
  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/suggestions/getters.js